document.addEventListener('turbolinks:load', () => {
  const input = document.querySelector('.js-time-zone-field');

  if (input) {
    input.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
});
